import axios from "axios";
import qs from 'qs';
// 本地环境api
// axios.defaults.baseURL = process.env.BASE_API
// 线上环境api
// axios.defaults.baseURL = 'http://fmz1.ourgame.com:56460'
// 自动匹配
// axios.defaults.baseURL =  process.env.NODE_ENV === 'development' ? "/activity/api" : "http://fmz.ourgame.com/"
// http://fmz1.ourgame.com/activity
axios.defaults.baseURL =  process.env.NODE_ENV === 'development' ? "/api" : "http://fmz.ourgame.com/activity"
// axios.defaults.baseURL =  process.env.NODE_ENV === 'development' ? "/api" : ( window.location.protocol + "//" + window.location.hostname )
// 创建一个AXIOS实例
const service = axios.create({
    // baseURL: process.env.VUE_APP_BASE_API // url = base url + request url
    // baseURL: 'xxxx' // 线上地址
    // baseURL: 'http://xxxxx', // 本地测试地址
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000, // 请求超时
})
// 添加请求拦截器: post请求的时候可以直接使用from-data的格式，不需要每次都编码转换
service.interceptors.request.use(function (config) {
    if(config.method=="post"){
      // 将数据格式作转换, post的请求参数格式是form-data
      config.data = qs.stringify(config.data);
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    } else if(config.method=="get") {
  }
    return config
      
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url,params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
};
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.post(url,data)
    .then(response => {
      resolve(response.data);
    },err => {
      reject(err)
    })
  })
};

export default service;


// WEBPACK FOOTER //
// ./src/utils/request.js